import { ISubSystemItemViewModel } from "../../../model/respone/user/ISubSystem";
import { eSubSystemActionTypeIds } from "../../action-types/sub-sytem/ISubSytemActionTypes";
import { baseAction } from "../IActionBase";

export const subSytemActions = {
    loadStart: () => baseAction(eSubSystemActionTypeIds.LOAD_START, undefined),
    loadSuccess: (data: ISubSystemItemViewModel[]) => baseAction(eSubSystemActionTypeIds.LOAD_SUCCESS, data),
    loadError: (message?: string) => baseAction(eSubSystemActionTypeIds.LOAD_ERROR, message ?? ""),
}